import { render } from "./numberData.vue?vue&type=template&id=16b1e44a"
import script from "./numberData.vue?vue&type=script&lang=js"
export * from "./numberData.vue?vue&type=script&lang=js"

import "./numberData.vue?vue&type=style&index=0&id=16b1e44a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__